import OnboardingJourney from "@/components/marketing/OnboardingJourney";
import Seo from "@/components/marketing/Seo";
import PublicSiteLayout from "@/components/layouts/PublicSiteLayout";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const IntroGettingStarted = () => {
  return (
    <PublicSiteLayout>
      <Seo
        title="Getting Started with HiredCoach | Build Your Story First"
        description="Preview the first-time HiredCoach onboarding step where users upload their resume and start building their career story."
        canonicalPath="/intro/getting-started"
      />

      <section className="bg-gradient-to-b from-[#f6fbff] to-white py-20">
        <div className="container mx-auto px-6">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-sky-700">Intro Preview</p>
            <h1 className="mt-4 text-4xl font-bold text-slate-900 md:text-5xl">
              First stop: build your story
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-600">
              New users start here because HiredCoach needs their resume context before it can coach with precision.
            </p>
          </div>

          <div className="mt-14">
            <OnboardingJourney activeStage="resume" />
          </div>

          <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-sky-100 bg-sky-50 p-8 text-center">
            <h2 className="text-2xl font-bold text-slate-900">Why this comes first</h2>
            <p className="mt-4 text-slate-600">
              Resume details create the foundation for job matching, interview prompts, and feedback that sounds like you instead of a generic candidate.
            </p>
            <Button asChild className="mt-6 rounded-full bg-sky-600 px-8 hover:bg-sky-500">
              <Link to="/intro/add-job">
                Next: Add a Job
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </PublicSiteLayout>
  );
};

export default IntroGettingStarted;
